/**
 * Created by Kshama on 3/10/17.
 */
angular.module('qkr').controller('ForumController',
    ForumController);

ForumController.$inject = ['appConfig', 'merchantInfoData', '$sce'];

function ForumController(appConfig, merchantInfoData, $sce) {
    const vm = this;
    const merchantInfo = merchantInfoData;

    let merchantNameParam = '';
    if (merchantInfo) {
        merchantNameParam = 'merchantName=' + merchantInfo.name;
    }
    vm.forumUrl = $sce.trustAsResourceUrl(appConfig.pathPrefix + '/forum/redirectUrl?' + merchantNameParam);
}




// WEBPACK FOOTER //
// ./src/controllers/forum.controller.js